<template>
    <v-container v-if="show" fill-height fluid grid-list-xl>
        <v-layout wrap v-if="!Brasil">
            <v-flex sm12 xs12 md12 lg12 grid-list-md>
                <div class="cell">
                    <v-icon>
                        mdi-account-alert
                    </v-icon>      
                    <span>{{PendenteAprovacao}}</span>
                </div>
                <div class="cell">
                    <v-icon>
                        mdi-account-check
                    </v-icon>      
                    <span>{{Aprovado}}</span>
                </div>                   
            </v-flex>
        </v-layout>
        <v-layout wrap v-if="Brasil">
            <v-flex sm12 xs12 md12 lg12 grid-list-md>
                <div class="cell">
                    <v-icon>
                        mdi-account-alert
                    </v-icon>      
                    <span>{{PendenteAprovacao}}</span>
                </div>
                <div class="cell">
                    <v-icon>
                        mdi-account-check
                    </v-icon>      
                    <span>{{Aprovado}}</span>
                </div>
                <div class="cell">
                    <v-icon>
                        mdi-account-search
                    </v-icon>      
                    <span>{{AguardandoColetaPPA}}</span>
                </div>
                <div class="cell">
                    <v-icon>
                        mdi-account-clock
                    </v-icon>      
                    <span>{{ColetadoPPA}}</span>
                </div>
                <div class="cell">
                    <v-icon>
                        mdi-account-remove
                    </v-icon>      
                    <span>{{ErroColetaPPA}}</span>
                </div>
                <div class="cell">
                    <v-icon>
                        mdi-account-question
                    </v-icon>      
                    <span>{{ErroRetornoPPA}}</span>
                </div>
                <div class="cell">
                    <v-icon>
                        mdi-account-arrow-left
                    </v-icon>      
                    <span>{{RetornoPPA}}</span>
                </div>
                <div class="cell">
                    <v-icon>
                        {{icons.mdiBadgeAccount}}
                    </v-icon>      
                    <span>{{ProcessadoSAPSF}}</span>
                </div>
                <div class="cell">
                    <v-icon>
                        {{icons.mdiBadgeAccountAlert}}
                    </v-icon>      
                    <span>{{ErroProcessamentoSAPSF}}</span>  
                </div>               
            </v-flex>
        </v-layout>        
    </v-container>
</template>

<script>
import { mdiBadgeAccount, mdiBadgeAccountAlert  } from '@mdi/js';
import PaisConstantes from '@/constants/corporativo/pais.js'

export default {
    props: {
        value:{
            type: String
        }
    },     
    data () {
        return {      
            icons:{
                mdiBadgeAccountAlert : mdiBadgeAccountAlert, 
                mdiBadgeAccount: mdiBadgeAccount
            }          
        }
    },    
    computed: {  
        show(){
            return this.value != null && this.value != undefined && this.value != "";
        },
        Brasil(){
            return PaisConstantes.brasil.codigoDuasLetras == this.value;
        },        
        PendenteAprovacao () {
            return this.$t('Views.Onboarding.Colaborador.Listar.legenda-PENDAPROV');            
        },
        Aprovado () {
            return this.$t('Views.Onboarding.Colaborador.Listar.legenda-APROVADO');            
        },
        ProcessadoNAI () {
            return this.$t('Views.Onboarding.Colaborador.Listar.legenda-PROCNAI');            
        },
        AguardandoColetaPPA () {
            return this.$t('Views.Onboarding.Colaborador.Listar.legenda-AGLEITPPA');            
        },
        ColetadoPPA () {
            return this.$t('Views.Onboarding.Colaborador.Listar.legenda-PROCCOLPPA');            
        },
        ErroColetaPPA () {
            return this.$t('Views.Onboarding.Colaborador.Listar.legenda-ERROCOLPPA');            
        },
        RetornoPPA () {
            return this.$t('Views.Onboarding.Colaborador.Listar.legenda-RETORNOPPA');            
        },
        ErroRetornoPPA () {
            return this.$t('Views.Onboarding.Colaborador.Listar.legenda-ERRORETPPA');            
        },
        ProcessadoSAPSF () {
            return this.$t('Views.Onboarding.Colaborador.Listar.legenda-PROCSAPSF');            
        },
        ErroProcessamentoSAPSF () {
            return this.$t('Views.Onboarding.Colaborador.Listar.legenda-ERROSAPSF');            
        }  
    },
    async created(){
    },
    async mounted(){                    
    },
    methods:{      
    }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/material-dashboard/variables";

.cell{
    float: left;
    span{
        margin-left: 5px;
        font-size: small;
    }
}
.cell:not(:first-child){
    padding-left: 15px !important;
}
</style>
